import emailjs from "@emailjs/browser";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase/config";

// ID pubblici EmailJS (sicuri lato client; il destinatario è configurato nel
// template EmailJS, MAI nel codice).
const EMAILJS_SERVICE_ID = "service_l1lml24";
const EMAILJS_TEMPLATE_ID = "template_ahtvtmb";
const EMAILJS_PUBLIC_KEY = "dC6I0QK6hq1oGTW8T";

/**
 * Invia una richiesta di accesso alla beta privata.
 * 1) Salva la richiesta in Firestore (best-effort: non blocca l'utente).
 * 2) Invia la notifica via EmailJS (canale primario).
 *
 * @param {{nome:string,email:string,professione:string,anniAttivita:string,fonte:string,strumentiUsati:string}} data
 */
export async function submitAccessRequest(data) {
  const createdAt = new Date().toLocaleString("it-IT");

  // 1) Persistenza best-effort su Firestore (richiede rules che consentano create).
  try {
    await addDoc(collection(db, "accessRequests"), {
      nome: data.nome,
      email: data.email,
      professione: data.professione,
      anniAttivita: data.anniAttivita,
      fonte: data.fonte,
      strumentiUsati: data.strumentiUsati,
      status: "new",
      createdAt: serverTimestamp(),
    });
  } catch (err) {
    // Non blocca l'invio: la notifica email resta il canale primario.
    console.error("accessRequests: scrittura Firestore fallita (verifica le rules):", err);
  }

  // 2) Notifica via EmailJS (canale primario: se fallisce, l'utente vede l'errore).
  await emailjs.send(
    EMAILJS_SERVICE_ID,
    EMAILJS_TEMPLATE_ID,
    {
      nome: data.nome,
      email: data.email,
      professione: data.professione,
      anniAttivita: data.anniAttivita,
      fonte: data.fonte,
      strumentiUsati: data.strumentiUsati,
      createdAt,
    },
    EMAILJS_PUBLIC_KEY
  );
}
